/**
 * 默认情感图标
 */
export const DefaultIconMap = {
  primary: 'info',
  secondary: 'info',
  success: 'check-s',
  warning: 'exclamation',
  danger: 'exclamation',
}

/**
 * 默认情感图标
 */
export const DefaultCircleIconMap = {
  primary: 'info-circle-s',
  secondary: 'info-circle-s',
  success: 'check-circle-s',
  warning: 'exclamation-circle-s',
  danger: 'times-circle-s',
}

/**
 * 主题配色 -- derived-variables: $colors
 */
export const Themes = ['white', 'light', 'dark', 'primary', 'secondary', 'success', 'warning', 'danger']

/**
 * 键盘
 */
export const KeyCode = {
  BackSpace: 8,
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
}
